import { useCallback, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { Button } from '@maistodos/design-system-web'

import { FeedbackModal } from '@/components/FeedbackModal'
import { PaymentRedirectModal } from '@/modules/checkout/components/PaymentRedirectModal'
import { useModal } from '@/modules/checkout/hooks/use-modal'
import { usePay } from '@/modules/checkout/hooks/use-pay'
import { PaymentFlowAnalytics } from '@/shared/utils/analytics'

import { FormRedirectProps } from './types'

export const FormRedirect = ({ id, paymentType }: FormRedirectProps) => {
  const { t } = useTranslation()

  const {
    isOpen: isOpenErrorModal,
    open: openErrorModal,
    close: closeErrorModal,
  } = useModal()

  const [isRedirecting, setIsRedirecting] = useState(false)

  const { mutate } = usePay(id)

  const onFailure = useCallback(() => {
    setIsRedirecting(false)
    openErrorModal()
  }, [openErrorModal])

  const onContinue = useCallback(() => {
    PaymentFlowAnalytics.onClickPayment()
    setIsRedirecting(true)

    mutate(
      { payment_type: paymentType.id },
      {
        onSuccess: (payment) => {
          if (!payment?.paymentRedirectUrl) {
            onFailure()
            return
          }

          window.location.href = payment.paymentRedirectUrl
        },
        onError: () => onFailure(),
      },
    )
  }, [mutate, onFailure, paymentType.id])

  return (
    <div className="flex flex-col items-start gap-spacing24">
      <Button type="button" loading={isRedirecting} onClick={onContinue}>
        {t('Continuar para pagamento')}
      </Button>

      <PaymentRedirectModal isOpen={isRedirecting} />

      <FeedbackModal
        type="error"
        isOpen={isOpenErrorModal}
        onClose={closeErrorModal}
        title={t('Erro no link de pagamento')}
        description={t(
          'Por favor, entre em contato com o responsável pelo link para mais informações.',
        )}
        footer={
          <Button variant="secondary" fullWidth onClick={closeErrorModal}>
            {t('Fechar')}
          </Button>
        }
      />
    </div>
  )
}
